<div class="modal-header bg-head py-2">
  <h6 class="modal-title">{{notification ?  'Update Notification': 'Create Notification' }}</h6>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="onCross()"
  ></button>
</div>

<div class="modal-body question-assign m-body px-3">
  <form [formGroup]="form">
    <!-- Notification ID -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification ID</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <input
            type="text"
            formControlName="notificationId"
            class="form-control form-control w-25"
          />
        </div>
      </div>
    </div>

    <!-- Notification Text -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Text</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <textarea
            rows="4"
            formControlName="notificationText"
            class="form-control w-100"
          ></textarea>
          <small
            class="text-danger"
            *ngIf="f.notificationText.touched && f.notificationText.invalid"
          >
            Field is required (max 2000 chars)
          </small>
        </div>
      </div>
    </div>

    <!-- Affected Area + Type Code -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Affected Area</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <div class="row g-1">
            <div class="col-6">
              <select
                class="form-select form-select w-100"
                formControlName="affectedArea"
              >
                <option value="" disabled>Select Area</option>
                <option *ngFor="let a of affectedAreas" [value]="a.Code">
                  {{ a.Description }}
                </option>
              </select>
            </div>
          </div>
          <small
            class="text-danger"
            *ngIf="f.affectedArea.touched && f.affectedArea.invalid"
          >
            Affected Area is Field is required
          </small>
        </div>
      </div>
    </div>

    <!-- Material ID -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Material ID</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <input
            type="text"
            class="form-control form-control w-50"
            formControlName="materialId"
          />
        </div>
      </div>
    </div>

    <!-- Notified Material Status -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notified Material Status</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <select
            class="form-select form-select w-50"
            formControlName="notifiedMaterialStatus"
          >
            <option value="" selected>Select Material Status</option>
            <option *ngFor="let s of materialStatuses" [value]="s.Code">
              {{ s.Description }}
            </option>
          </select>
          <small
            class="text-danger"
            *ngIf="f.notifiedMaterialStatus.touched && f.notifiedMaterialStatus.invalid"
            >Field is required</small
          >
        </div>
      </div>
    </div>

    <!-- Notification Severity -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Severity</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <select
            class="form-select form-select w-50"
            formControlName="severityCode"
          >
            <option value="" disabled>Select Severity</option>
            <option *ngFor="let s of severities" [value]="s.Code">
              {{ s.Description }}
            </option>
          </select>
          <small
            class="text-danger"
            *ngIf="f.severityCode.touched && f.severityCode.invalid"
            >Field is required</small
          >
        </div>
      </div>
    </div>

    <!-- Notification Method -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Method</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <select
            class="form-select form-select w-50"
            formControlName="methodCode"
          >
            <option value="" disabled>Select Method</option>
            <option *ngFor="let m of methods" [value]="m.Code">
              {{ m.Description }}
            </option>
          </select>
          <small
            class="text-danger"
            *ngIf="f.methodCode.touched && f.methodCode.invalid"
            >Field is required</small
          >
        </div>
      </div>
    </div>

    <!-- Require Acknowledgement -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Acknowledgement</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <select
            class="form-select form-select w-50"
            formControlName="requireAcknowledgement"
          >
            <option value="" disabled>Select Acknowledgement</option>
            <option
              *ngFor="let st of notifcationAcknowledgement"
              [value]="st.Code"
            >
              {{ st.Description }}
            </option>
          </select>
                    <small
            class="text-danger"
            *ngIf="f.requireAcknowledgement.touched && f.requireAcknowledgement.invalid"
            >Field is required</small
          >
        </div>
      </div>
    </div>

    <!-- Notification Status -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Notification Status</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <select
            class="form-select form-select w-50"
            formControlName="statusCode"
          >
            <option value="" disabled>Select Status</option>
            <option *ngFor="let st of statuses" [value]="st.Code">
              {{ st.Description }}
            </option>
          </select>
          <small
            class="text-danger"
            *ngIf="f.statusCode.touched && f.statusCode.invalid"
            >Field is required</small
          >
        </div>
      </div>
    </div>

    <!-- Release Date -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Release Date</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <div class="input-group input-group w-50">
            <input
              class="form-control"
              type="date"
              formControlName="releaseDate"
              [min]="minDate"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Withdrawal Date -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Withdrawal Date</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <div class="input-group input-group w-50">
            <input
              class="form-control"
              type="date"
              formControlName="withdrawalDate"
              [min]="minDate"
            />
          </div>
          <small
            class="text-danger"
            *ngIf="form.errors?.withdrawalBeforeRelease"
          >
            Withdrawal must be same or after Release date
          </small>
        </div>
      </div>
    </div>

    <!-- Withdrawal Reason -->
    <div class="col-12">
      <div class="row pt-1">
        <div class="col-3 text-right pr-0 pt-1 pl-0">
          <div class="d-flex flex-row-reverse">
            <div class="p-0">Withdrawal Reason Description</div>
          </div>
        </div>
        <div class="col-7 pl-2">
          <textarea
            rows="3"
            class="form-control w-100"
            formControlName="withdrawalReason"
          ></textarea>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm bl-btn" (click)="onSave()">
    Save
  </button>
  <button type="button" class="btn btn-sm bg-light border" (click)="onCross()">
    Cancel
  </button>
</div>
